export default "__VITE_ASSET__8JLbsKd9__"